module.exports = "<h3 class=\"alert alert-danger\">Page not found : 404 Error</h3>\n\n\n\n\n\n"